import { render, staticRenderFns } from "./ReportAdmin.vue?vue&type=template&id=66f7ef5c&"
import script from "./ReportAdmin.vue?vue&type=script&lang=js&"
export * from "./ReportAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports